<template>
  <div>
    <div @keyup.enter="login" class="form formBackground">
      <input
        v-model.trim="email"
        placeholder="Student ID"
        type="email"
        class="underline"
        style="margin-bottom: 1.2rem"
      />

      <input
        v-model="password"
        placeholder="REG Password"
        type="password"
        class="underline"
      />

      <!-- <p class="invalid" v-if="!$v.email.required" >Please input email and password</p> -->
      <CRow>
        <CCol xl="7" class="invalid">
          <span v-if="this.warningTextLogin">Invalid username or password</span>
          <span v-if="this.$store.getters['auth/authMessage'].en !== null">{{
            this.$store.getters['auth/authMessage'].en
          }}</span>
        </CCol>
        <CCol xl="5" class="text-right">
          <!-- <a @click="warningForgotPassword" class="forgot"
            >Need Help? Click Here</a
          > -->
          <!-- <a @click="setemail = true" class="forgot">Forgot password?</a> -->
        </CCol>
      </CRow>

      <CModal
        title="Modal title"
        :show.sync="setemail"
        :centered="true"
        add-content-classes="bgmodalmdl"
        :closeOnBackdrop="true"
      >
        <template #body-wrapper>
          <div class="modal-text">
            <div class="p-3 mt-1">
              <h1 class="ml-4 mt-4">FORGOT PASSWORD</h1>
              <p class="modal-text mt-4 mb-0 ml-4 mr-4">
                Please enter your registered e-mail address to reset your
                password
              </p>
              <input
                v-model.trim="email"
                placeholder="E-mail"
                type="email"
                class="underlineforgot mt-2 ml-4 mr-4"
                style="
                  padding-bottom: 0px;
                  padding-top: 0px;
                  padding-left: 0px;
                  padding-right: 0px;
                "
              />
              <p
                v-if="showingInvalidEmailondition"
                class="mt-1 ml-4 invalid"
                style="color: red"
              >
                Invalid Email
              </p>
              <p v-if="loadingOTP" class="mt-4 text-center" style="color: #000">
                <i class="fas fa-circle-notch fa-spin"></i>...Please wait
              </p>
              <CButton
                v-else
                @click="setVerifyModal()"
                class="btnforgot mt-4 mb-3"
                >SUBMIT</CButton
              >
            </div>
          </div>
        </template>
        <template #header-wrapper>
          <div></div>
        </template>
        <template #footer-wrapper>
          <div></div>
        </template>
      </CModal>

      <!-- verfify email -->
      <CModal
        :show.sync="setverrify"
        :centered="true"
        add-content-classes="bgmodalmdl"
        :closeOnBackdrop="false"
      >
        <template #body-wrapper>
          <div class="modal-text">
            <div class="p-3 mt-3">
              <h1 class="ml-4 mt-3">Verified</h1>
              <CCol>
                <input
                  v-model="token"
                  type="token"
                  placeholder="Fill your verify code from your registered e-mail"
                  class="underlineforgot ml-2 mt-3"
                  style="
                    padding-bottom: 0px;
                    padding-top: 0px;
                    padding-left: 0px;
                    padding-right: 0px;
                  "
                />
                <p class="ml-4"></p>
                <!--<u class="dontget">
                  <strong>
                    <em class="mr-2">Don't get one?</em>
                  </strong>
                </u>-->
              </CCol>
              <CButten
                v-if="renewSecret != ''"
                @click="verifyNewUser()"
                class="btnforgot mt-5 btn"
                >Submit</CButten
              >
              <CButton
                v-else
                @click="confirmForgotOTPmethods(setnewpassword)"
                class="btnforgot mt-5 btn"
                >Summit</CButton
              >
            </div>
          </div>
        </template>
        <template #header-wrapper>
          <div></div>
        </template>
        <template #footer-wrapper>
          <div></div>
        </template>
      </CModal>

      <!-- create new password -->
      <CModal
        :show.sync="setnewpassword"
        :centered="true"
        add-content-classes="bgmodalmdl"
        :closeOnBackdrop="false"
      >
        <template #body-wrapper>
          <div class="modal-text">
            <div class="p-3 mt-3">
              <h1 class="ml-4 mt-3">Reset Password</h1>
              <p class="ml-4 mt-4">Please enter your new password</p>
              <CCol>
                <input
                  :type="newPasswordType"
                  v-on:input="onChangeText(newPassword, 1)"
                  @input="new_password"
                  v-model="newPassword"
                  class="underlineforgot ml-2 pb-0"
                  placeholder="Enter your new password"
                  required
                />
                <CRow class="lnu_container ml-1 mb-3">
                  <CCol class="strong">
                    <p v-bind:class="{lovercase_valid: new_contains_lovercase}">
                      Lowercase
                    </p>
                  </CCol>
                  <CCol class="strong">
                    <p v-bind:class="{uppercase_valid: new_contains_uppercase}">
                      Uppercase
                    </p>
                  </CCol>
                  <CCol class="strong">
                    <p v-bind:class="{number_valid: new_contains_number}">
                      Number
                    </p>
                  </CCol>
                  <CCol class="strong">
                    <p
                      v-bind:class="{
                        uppercase_valid: new_valid_password_length,
                      }"
                    >
                      More than 7
                    </p>
                  </CCol>
                </CRow>
                <input
                  :type="confirmPasswordType"
                  v-model="confirmpassword"
                  v-on:input="onChangeText(confirmpassword, 2)"
                  class="underlineforgot ml-2 pb-0"
                  placeholder="Confirm Password"
                  required
                />
                <!-- <input
                                  :type="confirmPasswordType"
                                  @input="confirm_Password"
                                  v-model="confirmPassword"
                                  placeholder="Confirm Password"
                                  class="underlineforgot pb-1 mt-3 ml-2"
                />-->
              </CCol>
              <CRow>
                <CCol v-if="warningPassword" :class="isMatchPasswordStyle">{{
                  isMatchPassword
                }}</CCol>
              </CRow>
              <CButton @click="ResetPassword" class="btnforgot mt-4"
                >Summit</CButton
              >
            </div>
          </div>
        </template>
        <template #header-wrapper>
          <div></div>
        </template>
        <template #footer-wrapper>
          <div></div>
        </template>
      </CModal>

      <!--  forgot password modal -->
      <CModal
        title="Modal title"
        :show.sync="forgotPasswordWarning"
        :centered="true"
        add-content-classes="bgmodalmdl"
        :closeOnBackdrop="true"
      >
        <template #body-wrapper>
          <div class="modal-text-success">
            <div class="p-3 mt-1">
              <h1 class="mt-4">Contact Support</h1>
              <p class="modal-text mt-4 mb-0 mr-4">
                Please contact us via
                <a href="https://lin.ee/vENXiDs">MDL Line official</a>
              </p>

              <CButton
                @click="forgotPasswordWarning = false"
                class="btnforgot mt-3 mb-3"
                >OK</CButton
              >
            </div>
          </div>
        </template>
        <template #header-wrapper>
          <div></div>
        </template>
        <template #footer-wrapper>
          <div></div>
        </template>
      </CModal>
      <!-- Successfully reset Password -->
      <CModal
        title="Modal title"
        :show.sync="ResetPasswordSuccessStatus"
        :centered="true"
        add-content-classes="bgmodalmdl"
        :closeOnBackdrop="false"
      >
        <template #body-wrapper>
          <div class="modal-text-success">
            <div class="p-3 mt-1">
              <h1 class="mt-4">CHANGE PASSWAORD SUCCESSFUL</h1>
              <p class="modal-text mt-4 mb-0 mr-4">
                Please verify password resetting in your e-mail
              </p>
              <CButton
                @click="closeSuccessfullyModal()"
                class="btnforgot mt-3 mb-3"
                >OK</CButton
              >
            </div>
          </div>
        </template>
        <template #header-wrapper>
          <div></div>
        </template>
        <template #footer-wrapper>
          <div></div>
        </template>
      </CModal>
      <p v-if="loading" class="mt-4 text-center" style="color: #000">
        <i class="fas fa-circle-notch fa-spin"></i>...Please wait
      </p>
      <Button v-else :click="login" class="mt-4">SIGN IN</Button>
      <div class="needhelp">
        <a @click="warningForgotPassword">Need Help? Click Here</a>
      </div>

      <!-- for new sso login -->
      <div class="or-divider">
        <span class="a" style="color: grey">Or</span>
      </div>
      <div class="mt-4">
        <button class="button-sso-main button-sso-sub" @click="signInSSO">
          Login with MFU SSO
        </button>
      </div>

      <!-- <form>
        <fieldset>
          <legend align="center" style="font-style: italic">or</legend>
        </fieldset>
      </form> -->
      <!-- 
           @sdk-init="handleSdkInit"
          @login="facebookLogin"
          @sdk-loaded="sdkLoaded"
          app-id="654763245426257"
          -->
      <!-- <div class="mt-2">
        <v-facebook-login
          @click="test()"
          class="v-facebook-login button button-facebook"
        >
         
          <template #logo>
            <img
              src="@/assets/icons/facebook.svg"
              height="24"
              width="24"
              style="margin-right: 7px; padding-top: 1px"
            />
          </template>
          <template #login>
            <b style="font-size: 16px">Sign in with Facebook</b>
          </template>
          <template #logout>
            <b style="font-size: 16px">Sign in with Facebook.</b>
          </template>
        </v-facebook-login>
      </div>

      <div class="mt-2">
        <div>
          <button class="button button-google" @click="signInGoogleHandler">
            <img src="@/assets/icons/google.png" height="24" width="24" />
            <b class="authText">Sign in with Google</b>
          </button>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import Button from '../signInCss/Button';
import Facebook from './Facebook';
import {mapGetters} from 'vuex';
import VFacebookLogin from 'vue-facebook-login-component';

export default {
  name: 'Loginmdl',
  components: {
    Button,
    Facebook,
    VFacebookLogin,
  },
  data() {
    return {
      // clientId:
      //   "553738419453-k89tphdnkkvb0crthf9havd83iq3k7k2.apps.googleusercontent.com",
      errorHold: '',
      InvalidEmail: '',
      username: '',
      pass: '',
      // email: "6031006815",
      // password: "1",
      email: '',
      forgotPasswordWarning: false,
      password: '',
      icon: 'google',
      setemail: false,
      setverrify: false,
      setnewpassword: false,
      darkModal: false,
      isSignIn: false,
      successfullyResetPassword: false,
      token: '',
      secret: this.$store.getters.OTPSecretGetter,
      renewSecret: '',
      newPassword: null,
      new_password_length: 0,
      new_contains_lovercase: false,
      new_contains_number: false,
      new_contains_uppercase: false,
      new_valid_password_length: false,
      new_valid_password: false,
      newPasswordType: 'password',
      confirm_password: '',
      confirmpassword: '',
      showingInvalidEmailondition: false,
      confirmPasswordType: 'password',
      warningPassword: false,
      warningText: '',
      isMatchPassword: "Password doesn't match",
      isMatchPasswordStyle: '',
      loading: false,
      loadingOTP: false,
      warningTextLogin: false,
      isConnected: false,
      name: '',
      email: '',
      personalID: '',
      FB: undefined,
      authData: null,
      scope: {},
    };
  },

  formCollapsed: true,
  computed: {
    ...mapGetters([
      'userData',
      'dialog',
      'dialogForgotOTPHolderGetter',
      'OTPForgotSecretGetter',
      'dialogSetNewPasswordGetter',
      'dialogSetNewPasswordSecretGetter',
      'invalidEmailGetter',
      'ResetPasswordSuccessStatus',
      'userInformation',
    ]),
    ...mapGetters({
      getLoginErr: 'auth/authMessage',
      getLoading: 'auth/loading',
      getOTPLoading: 'getOtpLoading',
      getNewSecret: 'auth/newSecret',
      checkVerifyModalGetter: 'auth/modalVerifyOTP',
      registerSuccessStatus: 'registerSuccessStatus',
      logoutProfile: 'profile/getProfile',
    }),
  },
  mounted() {
    this.$store.commit('auth/setCloseModalVerifyOTP');
    this.setverrify = false;
  },
  watch: {
    getOTPLoading(value) {
      this.loadingOTP = value;
    },
    getLoading(value) {
      this.loading = value;
    },
    getNewSecret(value) {
      this.renewSecret = value;
      this.setverrify = true;
    },
    getLoginErr(value) {},
    logoutProfile(value) {
      this.email = null;
      this.password = null;
    },
    invalidEmailGetter: function (value) {
      this.showingInvalidEmailondition = value;
    },
    dialogSetNewPasswordGetter: function (val) {
      this.setnewpassword = val;
    },
    dialogForgotOTPHolderGetter: function (value) {
      this.setverrify = value;
      this.setemail = false;
    },
    checkVerifyModalGetter: function (val) {
      this.setverrify = true;
    },
    OTPForgotSecretGetter: function (value) {
      this.secret = value;
    },
    dialogSetNewPasswordSecretGetter: function (value) {
      this.secret = value;
    },
    email: function () {
      if ((this.email === '') & (this.password === '')) {
        this.warningTextLogin = true;
      }
    },
    password: function () {
      this.warningTextLogin = false;
    },
    registerSuccessStatus: function (value) {
      if (value == true) {
        this.setverrify = false;
        //this.login();
      }
    },
  },

  created() {
    this.$store.commit('closeDialog');
    this.$store.commit('closeDialog2');
    this.$store.commit('disableInvalidEmailWarning');
    this.$store.commit('closeRegisterSuccessModal');
    this.$store.commit('auth/setCloseModalVerifyOTP');
    this.setverrify = false;
    this.deleteMessage();
    // this.closedia()
  },
  methods: {
    warningForgotPassword() {
      this.forgotPasswordWarning = true;
    },
    clearData() {
      this.newPassword = '';
      this.confirmpassword = '';
    },
    new_password: function () {
      this.new_password_length = this.newPassword.length;
      if (this.new_password_length > 7) {
        this.new_valid_password_length = true;
      } else {
        this.new_valid_password_length = false;
      }

      this.new_contains_lovercase = /[a-z]/.test(this.newPassword);
      this.new_contains_number = /\d/.test(this.newPassword);
      this.new_contains_uppercase = /[A-Z]/.test(this.newPassword);

      // Check if the password is valid
      if (
        this.new_contains_lovercase == true &&
        this.new_contains_number == true
      ) {
        this.new_valid_password = false;
        if (
          this.new_contains_uppercase == true &&
          this.new_valid_password_length == true
        )
          this.new_valid_password = true;
      } else {
        this.new_valid_password = false;
      }
    },
    closeSuccessfullyModal: function () {
      // this.successfullyRegister = false;
      this.$store.commit('closeResetPasswordSuccessModal');
    },
    showNewPassword() {
      this.newPasswordType =
        this.newPasswordType === 'password' ? 'text' : 'password';
    },
    showConfirmPassword() {
      this.confirmPasswordType =
        this.confirmPasswordType === 'password' ? 'text' : 'password';
    },
    deleteMessage() {
      this.$store.commit('auth/closeAlertStatus');
    },
    signInGoogleHandler() {
      alert('Sorry, logging in with Google is not available now.');
      // this.$gAuth
      //   .signIn()
      //   .then((user) => {
      //     let body = {
      //       accessToken: user.xc.access_token,
      //     };
      //     this.$store.dispatch("auth/loginGoogle", body);
      //     this.isSignIn = this.$gAuth.isAuthorized;
      //   })
      //   .catch((error) => {});
    },
    signOutGoogleHandler() {},
    login() {
      this.warningTextLogin = false;
      const payload = {
        username: this.email,
        password: this.password,
      };
      if (
        payload.username == '' ||
        payload.username == null ||
        payload.password == '' ||
        payload.password == null
      ) {
        this.warningTextLogin = true;
      } else {
        this.$store.dispatch('auth/onLogin', payload);
        let testerVar = this.$store.getters['auth/modalVerifyOTP'];
      }
      // this.emit('closeModal',false);
    },

    onForgotPassword() {
      let forgotPasswordData = {
        email: this.email,
      };
      this.$store.dispatch('onForgotPassword', forgotPasswordData);
    },
    setVerifyModal() {
      let data = {
        email: this.email,
      };
      this.$store.dispatch('confirmForgotOTPaction', data);
    },
    ResetPassword() {
      let secretHolder = this.$store.getters.dialogSetNewPasswordSecretGetter;
      let resetpasswordData = {
        token: this.token,
        secret: secretHolder,
        newPassword: this.newPassword,
      };
      if (this.confirmpassword != this.newPassword) {
        alert('password not match');
      } else {
        this.$store.dispatch('onResetPassword', resetpasswordData);
      }
    },
    onChangeText(textHolder, id) {
      if (id == 1) {
        this.newPassword = textHolder;
      } else if (id == 2) {
        this.confirmpassword = textHolder;
        if (this.confirmpassword != this.newPassword) {
          this.isMatchPasswordStyle = 'error-password-forgot';
          this.warningPassword = true;
          this.isMatchPassword = "Password doesn't match";
        }
        if (this.confirmpassword == this.newPassword) {
          this.isMatchPasswordStyle = 'match-password';
          this.isMatchPassword = 'Password matches';
          this.warningPassword = true;
        }
      }
    },
    verifyNewUser() {
      let payload = {
        token: this.token,
        secret: this.renewSecret,
      };
      this.$store.dispatch('confirmOTPaction', payload);
    },
    confirmForgotOTPmethods() {
      let secretHolder = this.$store.getters.OTPForgotSecretGetter;
      let payload = {
        token: this.token,
        secret: secretHolder,
      };
      this.$store.dispatch('onVerifyForgotAction', payload);
    },
    closedia() {
      this.$store.commit('closeDialog');
    },

    //// Facebook Login ////////
    signInFacebookHandler() {
      document.getElementById('btnFacebook').click();
    },
    sdkLoaded(payload) {
      this.FB = payload.FB;
    },
    facebookLogin() {
      let body = {};
      // this.FB.getLoginStatus(function (response) {
      //   body = {
      //     accessToken: response.authResponse.accessToken,
      //   };
      // });
      // this.$store.dispatch("auth/facebookLogin", body);
    },
    handleSdkInit({FB, scope}) {
      this.FB = FB;
      this.scope = scope;
    },
    getUserData() {
      this.FB.api('/me', 'GET', (response) => {
        this.personalID = response.id;
        this.email = response.email;
        this.name = response.name;
      });
    },

    ////// SSO Login///////
    signInSSO() {
      //handle login
      this.$store.dispatch('auth/ssoAuthorize');
    },
  },
};
</script>

<style>
.bgmodalmdl {
  border-radius: 30px;
}
</style>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500;700;900&display=swap');

.overflow-auto {
  overflow: auto !important;
  backdrop-filter: blur(20px) !important;
}

element.style {
  overflow: auto !important;
  backdrop-filter: blur(20px) !important;
}

.dontget {
  float: right;
  font-size: 12px;
  margin-right: 0.5em;
  color: black;
}

.modal-text h1 {
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 24px;
  color: black;
  text-align: left;
}

.error-password {
  font-size: 10px;
  font-family: 'Roboto', sans-serif;
  color: #ff4a4a;
  font-style: italic;
  margin-top: 0.5em;
}

.modal-text-success h1 {
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 24px;
  color: black;
  text-align: center;
}

.modal-text-success p {
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
  font-size: 16px;
  color: black;
  text-align: center;
}

.modal-text p {
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
  font-size: 16px;
  color: black;
  text-align: left;
}

.modalText {
  font-size: 18px;
}

.button-google {
  color: #ea4335;
  background-color: white;
}

#app input[type='password'] {
  width: 320px;
  height: auto;
  border: 1px solid transparent;
  background: #eeeeee;
  color: #475762;
  font-size: 15px;
  border-radius: 4px;
  padding: 12px 5px;
  overflow: hidden;
  outline: none;
  -webkit-transition: all 0.1s;
  transition: all 0.1s;
}

.password_length {
  padding: 2px 10px;
  position: absolute;
  top: 50%;
  right: 10px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  background: #fbd490;
  color: rgba(71, 87, 98, 0.8);
  border-radius: 4px;
  font-size: 13px;
  display: none;
  -webkit-transition: all 0.1s;
  transition: all 0.1s;
}

.button {
  outline: none;
  width: 100%;
  text-align: center;
  padding-top: 12px;
  padding-bottom: 12px;
  border-radius: 40px;
  font-size: 16px;
  border: 1px solid #cccccc;
}

.form {
  /* t r b l */
  padding: 30px 36px 40px 36px;
}

.invalid {
  color: red;
  font-size: 12px;
  margin-top: 0.7em;
  font-style: italic;
}

#signin
  > div
  > div.form.formBackground
  > div:nth-child(5)
  > div.modal.overflow-auto.fade.show.d-block
  > div
  > div
  > div.modal-text
  > div
  > p {
  color: red;
  font-size: 12px;
  margin-top: 0.7em;
  font-style: italic;
  float: left;
}

.forgot {
  color: black;
  font-size: 12px;
  margin-top: 0.7em;
  background: none !important;
  cursor: pointer;
}
.forgot:hover {
  color: #666;
}

#info-block section {
  border-top: 1px solid #cccccc;
  text-align: center;
}

.file-marker > div {
  padding: 0 12px;
  margin-top: -1.03em;
  margin-bottom: 0.9em;
}

input {
  width: 100%;
  font-size: 20px;
  padding-bottom: 9px;
}

.underline {
  border: 0;
  outline: 0;
  background: transparent;
  border-bottom: 1px solid #cccccc;
  font-size: 14px;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: gray;
  opacity: 1; /* Firefox */
  font-weight: 100%;
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: white;
  opacity: 0.8;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: white;
  opacity: 0.8;
}

.textmodal p {
  font-size: 25px;
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
}

.modal-title {
  font-size: 25px;
  font-family: 'Roboto', sans-serif;
}

::placeholder {
  font-family: 'Roboto', sans-serif;
  font-weight: 100%;
}

.btnforgot {
  display: block;
  background-color: #0080ff;
  width: 173px;
  border-radius: 30px;
  padding-left: auto;
  color: white;
  font-size: 16px;
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  text-align: center;
  margin: 0 auto;
}

.underlineforgot {
  border: 0;
  outline: 0;
  background: transparent;
  width: 95%;
  border-bottom: 0.5px solid #cccccc;
}

fieldset {
  display: block;
  margin: 20px 1%;
  margin-bottom: 20px;
  padding: 0 auto;
  padding: 15px 0;
  border: 0;
  border-top: 1px solid #cccccc;
  width: 98%;
}

fieldset:last-of-type {
  margin-bottom: 0px;
}

legend {
  display: table;
  min-width: 0px;
  max-width: 8%;
  margin: auto;
  color: black;
  font-size: 12px;
  text-align: center;
}

.formBackground {
  background-color: white;
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
}

.authText {
  font-size: 16px;
  margin-left: 7px;
}

#signin
  > div
  > div.form.formBackground
  > div:nth-child(4)
  > div.modal.overflow-auto.fade.show.d-block
  > div
  > div
  > div.modal-text
  > div
  > input {
  width: 86%;
}

.yellow {
  width: 98px;
  height: 5px;
  background-color: #ffe200;
  border-radius: 10px;
  float: left;
}

.green {
  width: 98px;
  height: 5px;
  background-color: #00e859;
  border-radius: 10px;
  float: left;
}

.blue {
  background-color: #0080ff;
  width: 98px;
  height: 5px;
  border-radius: 10px;
  float: left;
}

.gray {
  background-color: #cccccc;
  width: 98px;
  height: 5px;
  border-radius: 10px;
  float: left;
}

.lovercase_valid,
.number_valid,
.uppercase_valid {
  background-position: left !important;
  color: rgba(255, 255, 255, 0.9) !important;
}

.lnu_container {
  margin-top: 0.5rem;
  width: 97%;
  height: auto;
  display: flex;
}

.lnu_container p {
  width: 100%;
  font-size: 10.7px;
  line-height: 2;
  text-align: center;
  border-radius: 2px;
  color: rgba(71, 87, 99, 0.8);
  background: linear-gradient(to right, #0080ff 50%, #eee 50%);
  background-size: 201% 100%;
  background-position: right;
  -webkit-transition: background 0.3s;
  transition: background 0.3s;
}

.strong {
  padding-left: 0;
  padding-right: 3px;
  margin-bottom: -30px;
}

.error-password-forgot {
  font-size: 16px;
  font-family: 'Roboto', sans-serif;
  color: #ff4a4a;
  font-style: italic;
  margin-top: 0.5em;
  margin-left: 1.5em;
}

.match-password {
  font-size: 16px;
  font-family: 'Roboto', sans-serif;
  color: #00cc00;
  font-style: italic;
  margin-top: 0.5em;
  margin-left: 1.5em;
}

@import '../signInCss/signIn.css';
</style>
